export default {
  props: {
    title: {
      type: Object,
    },
    subtitle: {
      type: String,
    },
    buttons: {
      type: Array,
    },
  },
}
